module.exports = __webpack_public_path__ + "static/pages-e22bd222ff564627edef4cca7b9e840d.svg";